<template>
    <div class="home-page">
		<Header></Header>
		<div class="content">
			<div class="nav flex">
				<div class="back" @click="back">
					<img src="static/images/return.png" />
				</div>
				<span class="">{{$t('myAccount')}}</span>
			</div>
			<div class="information mt20">
        <div class="ac">
            <div class="my-account" v-if="!info.ace">
              <span>
              <img class="" src="static/images/accout-img.png" />
              </span>
            </div>
            <div class="my-account2" v-else>
            </div>
            <div class="phone ovhidden fs40 mt10">{{info.mobile}}</div>
        </div>
        <div class="proccess disflex">
          <div class="qian">
            {{info.successions*10}}%
          </div>
          <div class="proccess-c">
            <div class="proccess-c2" :style="'width:'+(info.successions*10)+'%'">
            </div>
          </div>
          <div class="last">
            <img class="" src="static/images/acc-img1.png" />
          </div>
        </div>
        <div class="account-list disflex mt30 ">
          <div class="name">
            {{$t('Name')}}
          </div>
          <div class="account-list-c fs27">
            <span class="name-span" v-if="!isEdit">{{info.nickname}}</span>
            <input class="name-input" v-if="isEdit" v-model="nickname" />
          </div>
          <span class="crff1d4f fs33" @click="editName">
            <img src="static/images/edit.png" v-if="!isEdit" />
            <button class="btn btn-blue" v-else style="padding:0 5px;">{{$t('Save')}}</button>
          </span>
        </div>
        <div class="account-list disflex mt30 ">
          <div class="name">
            {{$t('phone')}}
          </div>
          <div class="account-list-c fs27">
            <span class="name-span">{{info.mobile}}</span>
          </div>
          <span class="crff1d4f fs33" style="width:22px ;">
            &nbsp;
          </span>
        </div>
				<div class="price fw7 fs33 mt100">
          <div class="ac fs40">
            {{$t('YourRecords')}}
          </div>
					<div class="account-p flex mt20">
						<span class="one">{{$t('menmberSince')}}</span>
						<span class="two">:</span>
						<span class="three">{{info.jointime.substring(0, 10)}}</span>
					</div>
					<div class="account-p flex">
						<span class="one">{{$t('lastLogin')}}</span>
						<span class="two">:</span>
						<span class="three">{{info.prevtime.substring(0, 10)}}</span>
					</div>
					<div class="account-p flex">
						<span class="one">{{$t('gamesYouPlay')}}</span>
						<span class="two">:</span>
						<span class="three">{{info.play_count}}</span>
					</div>
					<div class="account-p flex">
						<span class="one" v-html="$t('playAce')"></span>
						<span class="two">:</span>
						<span class="three">{{info.ace?$t('Yes'):$t('No')}}</span>
					</div>
				</div>
        <div class="unsubscribe ac mt100" @click="unSubscribe">
        	<button class="btn btn-red ">{{$t('UNSUBSCRIBE')}}</button>
        </div>
			</div>
		</div>

    <Dialog ref="saveDialog" :callback="saveModal" title="Reminder" :btnText="$t('Yes')" :cancelText="$t('No')">
        <div slot="mdBox" >
            <div class="">{{$t('des2')}}</div>
        </div>
    </Dialog>
	</div>
</template>
<script>
import Header from '../components/headerNo'
import Dialog from '../components/dialog'

export default {
    components:{
		Header,
    Dialog
    },
    data() {
        return {
          disAbled:'',
          edit:'Edit',
          isEdit:false,
          info:'',
          nickname:'',

        }
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.edit = this.$t('Edit')
		this.getHome();

	},
    methods: {
		back(){
			this.$router.go(-1);
		},
    editName(){
    	let that = this;
    	if(that.nickname==''){
    		that.nickname = that.info.name
    	}
    	if(that.isEdit){
        let data = {
          nickname:that.nickname,
        }
    		that.$api.post('/api/user/profile',data,r =>{
    			that.$parent.returnCode(r,function(){
    				that.getHome()
            that.isEdit = false;
    				that.$parent.loadModal(false);
    			});

    		})
    	}else{
    		this.isEdit = true;
    	}
    },
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.post('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
					that.info = r.data
					that.$parent.loadModal(false);
        });

			})
		},
    unSubscribe(){
    	this.$refs.saveDialog.showMaskFun();
    },
    // 弹框保存
    saveModal (){
      let that =this;
      that.$api.post('/api/user/unsubscribe',null,r =>{

        localStorage.removeItem('token')
        this.$router.push({path:'/subscribe',query:{}});

          /*that.$utils.alertText(r.msg,80,3000);
          if(r.code==1){
            localStorage.removeItem('token')
            this.$router.push({path:'/subscribe',query:{}});
          }else{
            this.$refs.saveDialog.closeMask();
          }*/
      })

    },
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/myAccount.vue